import * as React from "react";

import images from "../../constants/images";
import Banner from "../../components/Common/Banner";

export default function Images() {
  return (
    <>
      <Banner image={images.bnr_default} />
    </>
  );
}
